/**
 * Single source of truth for the frontend app version.
 * Bump this on every meaningful release so the environment banner shows
 * exactly which build is running.
 */
export const APP_VERSION = "1.0.1-dev";
